import { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

// import Loader from '../../Loader/Loader';
import Backdrop from '../../Backdrop/Backdrop';
import ModalConfirm from '../../Modal/ModalConfirm';

import { useStore } from '../../../hook-store/store';
import { 
  cardExpire,
  getCustomerCardPaymentMethods,
 } from '../../../utils/stripe/payment-method-utils';

 import { BACKEND_URL } from '../../../App'

 import './PaymentMethods.css';
// import classes from './PaymentMethods.module.css';

function InvalidMethodMessage(props) {
  const {
    // subscriptionId,
    // isSubscribe,
  } = props;
  
  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    customerMethods,
    subscriptions,
    currentSubscription,
    validSubscriptionMethod,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [showInvalidMethod, setShowInvalidMethod] = useState(true);
  const [isValidMethod, setIsValidMethod] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    //// set true to hide message
    setIsValidMethod(true);

    if (showInvalidMethod && currentSubscription && !validSubscriptionMethod) {
        setIsValidMethod(false);
    }

    if (showInvalidMethod && currentSubscription && !currentSubscription.default_payment_method) {
        setIsValidMethod(false);
      }
  },[currentSubscription, validSubscriptionMethod]);

  useEffect(() => {
    if (!showInvalidMethod && !isValidMethod) {
      setTimeout(() => {
        setShowInvalidMethod(true);
      }, 1000*2);
    }
  },[showInvalidMethod, isValidMethod]);

  let isSubscriptionPage = false;
  const pathname = window.location.pathname;
  const sPathname = pathname.split('/');

  // console.log('sPathname', sPathname);

  if (sPathname?.length > 0 && sPathname[1] === 'subscription') {
    isSubscriptionPage = true;
  }

  let invalidMethodMessageBody;

  if (!isSubscriptionPage && !isValidMethod && showInvalidMethod) {
    invalidMethodMessageBody = (
      <div>
          <Backdrop
            zIndex={"110"}
            // backgroundColor={'rgba(0, 0, 0, 0.1)'}
            onCancel={() => {
              if (!isLoading) {
                setShowInvalidMethod(false);
                // setShowConfirmModal(false);
              }
            }}
          />
          <ModalConfirm
            hideButtons={true}
            onClose={() => {
              setShowInvalidMethod(false);
              // setShowConfirmModal(false);
            }}
            onAccept={() => {
              if (!isLoading) {
              }
            }}
            isLoading={isLoading}
          >
            <div>
              <div className='paymentMethodsRow'>
                {t('paymentMethod13', 'Valid payment method for subscription is not found.')}
              </div>
              <div className='paymentMethodsRow'>
                <Link
                  to='/subscription/account'
                >
                  {t('paymentMethod14', 'Please update payment method from subscription page.')}
                </Link>
              </div>
              <div className='paymentMethodsRow'>
                <Link
                  to='/subscription/account'
                >
                  <button className='btnBase'>
                    {t('paymentMethod15', 'Go to subscription page')}
                  </button>
                </Link>
              </div>
            </div>
          </ModalConfirm>
      </div>
    );
  }
 

  return (
    <Fragment>
      <div>
        {invalidMethodMessageBody}
      </div>
    </Fragment>
  );
}

export default InvalidMethodMessage;
